ReceivedGiftCard: You Received A Gift Card
HaveGiftCard: You Have A Gift Card
Sender: 'Sender: {0}'
IssuedDate: 'Issued Date: {0}'
Expires: 'Expires: {0}'
Close: Close
Refuse: Refuse
Accept: Accept
